<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { Bars3Icon } from '@heroicons/vue/24/outline'
import Sidebar from './Sidebar.vue'
import StagingBanner from '@/components/shared/StagingBanner.vue'
import CustomerSpotlightHost from '@/components/customers/CustomerSpotlightHost.vue'

const sidebarOpen = ref(false)
const route = useRoute()

watch(() => route.fullPath, () => {
  sidebarOpen.value = false
})
</script>

<template>
  <div class="flex h-screen w-full flex-col overflow-hidden">
    <StagingBanner />
    <div class="flex min-h-0 flex-1 overflow-hidden">
      <Sidebar :open="sidebarOpen" @close="sidebarOpen = false" />

      <div class="flex min-h-0 min-w-0 flex-1 flex-col">
        <!-- Mobile top bar -->
        <header class="flex items-center justify-between border-b border-gray-200 bg-white px-4 py-3 md:hidden">
          <button
            class="rounded-lg p-2 text-gray-600 hover:bg-gray-100"
            aria-label="Open navigation"
            @click="sidebarOpen = true"
          >
            <Bars3Icon class="h-6 w-6" />
          </button>
          <span class="font-lightbase text-xl text-forest font-black">Lightbase</span>
          <span class="w-10" aria-hidden="true" />
        </header>

        <div class="min-h-0 min-w-0 flex-1 overflow-y-auto">
          <slot />
        </div>
      </div>
    </div>

    <CustomerSpotlightHost />
  </div>
</template>
